<template>
  <BaseDataList ref="dataList" :items="approvalRequests" :service="loadList" lazy>
    <template #custom-action>
      <ApprovalRequestCreateAction
        :project-asset="projectAsset"
        @approval-request-created="onApprovalRequestCreated"
      />
    </template>

    <template #header>
      <ApprovalRequestListHeader />
    </template>

    <template #default="{ item }">
      <ApprovalRequestListItem
        :approval-request="item"
        :project="project"
        @approval-request-revoked="onApprovalRequestRevoked"
        @email-sent="refreshList"
      />
    </template>
  </BaseDataList>
</template>

<script>
import ApprovalRequestCreateAction from './ApprovalRequestCreateAction.vue';
import ApprovalRequestListHeader from './ApprovalRequestListHeader.vue';
import ApprovalRequestListItem from './ApprovalRequestListItem.vue';

export default {
  components: {
    ApprovalRequestListHeader,
    ApprovalRequestListItem,
    ApprovalRequestCreateAction,
  },
  props: {
    projectAsset: {
      type: Object,
      required: true,
    },
    approvalRequests: {
      type: Array,
      default: () => [],
    },
    loadList: {
      type: Function,
      required: true,
    },
  },
  computed: {
    project() {
      return this.$store.state.entities.projects.byId[this.projectAsset.projectId];
    },
  },
  methods: {
    refreshList() {
      this.$refs.dataList.fetchList();
    },
    onApprovalRequestRevoked() {
      this.refreshList();
      this.$emit('approval-request-list-changed');
    },
    onApprovalRequestCreated() {
      this.$refs.dataList.fetchList();
    },
  },
};
</script>
